import { AuthorizationModel } from "../../authentication/models/authorization-model";

export class AuthorizedCollection extends Backbone.Collection<any> {

    private dataXHR: JQueryXHR;

    public fetchRequest(options?: any): void {
        options = options || {};
        this.cancelOutstandingRequests();
        _.extend(options, { beforeSend: AuthorizationModel.attachAuthorizationHeader, cache: false });
        this.dataXHR = this.fetch(options);
    }

    private cancelOutstandingRequests() {
        if (this.dataXHR) { this.dataXHR.abort(); }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/authentication/models/authorized-collection.ts